import {Button} from '@/components/ui/button';
import {Toaster} from '@/components/ui/sonner.tsx';
import {getError} from '@/lib/ErrorHandler.ts';
import {t} from 'i18next';
import {useAuthUtils} from '@/hooks/useAuthUtils.ts';

export default function CustomErrorPage() {
  const errorData = getError();
  const {authRedirect} = useAuthUtils();
  const { title, errorMessage, buttonLabel, statusCode } =
  window.history.state?.errorData ||
  errorData ||
  {
    title: 'Generic.UnexpectedError.Title',
    errorMessage: 'Generic.UnexpectedError',
    buttonLabel: 'Generic.BtnBack',
    statusCode: undefined
  };

  return (
    <div className="mb-[100px] ml-[70px] mt-[50px]">
      <Toaster richColors />
      <h1 className="max-w-[700px] text-4xl font-bold">{t(title)}</h1>

      <div className="mt-[30px] flex max-w-[700px] flex-col gap-8 text-lg">
        <p className="font-bold">{t(errorMessage)}</p>
        <p className="font-bold">{t('Generic.ErrorCode')}: {statusCode ?? t('Generic.Unknown')}</p>
        <div className="flex">
          <Button
            variant="default"
            onClick={() => authRedirect()}
          >
            {t(buttonLabel)}
          </Button>
        </div>
      </div>
    </div>
  );
}
